import React, { useEffect } from "react";
import { logoutAccount } from "storeAccount/actions/Auth";
import { connect } from "react-redux";
import { RootStateAccount } from "storeAccount/accountStore";
import { bindActionCreators } from "redux";
import { AuthenticationState } from "storeAccount/reducers/Authentication";
import { useAccountTranslation } from "../translations";
import { getThemeApplicationUrl, useTheme } from "theme";

interface Props {
  authentication: AuthenticationState;
}

interface Actions {
  logoutAccount: () => void;
}

const Logout: React.FC<Actions & Props> = ({ authentication, logoutAccount }) => {
  const { t } = useAccountTranslation();
  const theme = useTheme();

  useEffect(() => {

    if (authentication === "") {
      const payload = typeof window !== "undefined" && window.btoa(JSON.stringify({ redirect_url: `${window.location.origin}/auth-return` }));
      window.location.assign(getThemeApplicationUrl(theme, "auth", `/entry/${payload}`))
    }

  }, [authentication, theme])



  return <button type="button" className="account-logout-button" onClick={logoutAccount}>
    <span><i className="mdi mdi-logout-variant" aria-hidden="true" /></span>
    {t("logout")}
  </button>;
};


const mapStateToProps = (state: RootStateAccount) => {
  return {
    authentication: state.Authentication
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ logoutAccount }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
